/** Measured native sender cadence and picture. Missing cadence means no usable sample yet. */
export type NativeEncodeDebug = {
  framesPerSecond?: number;
  frameWidth?: number;
  frameHeight?: number;
  encodeP50Ms?: number;
  encodeP95Ms?: number;
  queueP50Us?: number;
  queueP95Us?: number;
};

/** Computes RTP encode cadence from the sender's counter and monotonic clock, independent of IPC delay. */
export class NativeRtpTelemetry {
  private previous?: { frames: number; sampledAtUs: number };

  read(body: Record<string, unknown>): NativeEncodeDebug | undefined {
    const frames = body['framesEncoded'], sampledAtUs = body['sampledAtUs'];
    if (!Number.isSafeInteger(frames) || (frames as number) < 0 || !Number.isSafeInteger(sampledAtUs) || (sampledAtUs as number) <= 0) return;
    const sample = { frames: frames as number, sampledAtUs: sampledAtUs as number };
    const previous = this.previous;
    if (previous && sample.sampledAtUs <= previous.sampledAtUs) return;
    this.previous = sample;
    const framesPerSecond = previous && sample.frames >= previous.frames
      ? (sample.frames - previous.frames) * 1_000_000 / (sample.sampledAtUs - previous.sampledAtUs) : undefined;
    const positive = (key: string): number | undefined => {
      const value = body[key];
      return typeof value === 'number' && Number.isFinite(value) && value > 0 ? value : undefined;
    };
    return { framesPerSecond, frameWidth: positive('width'), frameHeight: positive('height'),
      encodeP50Ms: positive('encodeP50Ms'), encodeP95Ms: positive('encodeP95Ms') };
  }
}
